// Implement related brands router.js from plugins/router
// Update package.json proxy
// Update .env REACT_APP_BRAND_CODE
import { withRouter } from 'react-router-dom';

const {
  Router,
} = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/pages/router/index.js`);

export default withRouter(Router);



// WEBPACK FOOTER //
// ./src/components/router.js